import { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { RateReview } from '@material-ui/icons'

import { useTableReducer } from '@base'
import { Table, TableActionButton, TableActionsWrapper } from '@baseV2'
import { getAllTenderBookLeads } from '@data'
import { DRAWER_TYPES, strings, TenderBookLeadsFilter } from '@constants'
import { toggleDrawer } from '@data/state/action/root'
import { useForceUpdate } from '@hooks'
import { FullHeightPageLevelTableWrapper } from '@pages/Admin/Tenderbook/styles'
import FollowUpStatusPill from '@pages/Admin/Tenderbook/components/FollowUpStatusPill'

const ROWS_PER_PAGE = 10

const TenderBookLeadsList = () => {
	const [state, dispatch, actions] = useTableReducer(TenderBookLeadsFilter)
	const globalDispatch = useDispatch()
	const [forceUpdate, update] = useForceUpdate()

	useEffect(() => {
		if (state.loading) return

		dispatch(actions.fetchTableDataProgress())
		getAllTenderBookLeads({ ...state.query.filters, page: state.query.page, size: ROWS_PER_PAGE })
			.then((response) => {
				dispatch(actions.fetchTableDataSuccess(response.data, response.count))
			})
			.catch((error) => {
				dispatch(actions.fetchTableDataFailure(error))
			})
			.finally(() => {})
	}, [state.query, forceUpdate])

	// Sorting stays off: the table is server-paginated, so v2's built-in sort would only
	// reorder the page in view.
	const columns = useMemo(() => {
		return [
			{ label: strings('company_name'), key: 'company_name', sortable: false, mobile: true },
			{ label: strings('name'), key: 'name', sortable: false, mobile: true },
			{ label: strings('mobile', 'number'), key: 'mobile_no', sortable: false, mobile: true },
			{ label: strings('email_id'), key: 'email_id', sortable: false, mobile: true },
			{ label: strings('keywords'), key: 'keywords', sortable: false, renderer: (data) => data?.join(', ') },
			{ label: strings('created_date'), key: 'created_date', sortable: false },
			{
				label: 'Follow up status',
				key: 'follow_up_status',
				sortable: false,
				mobile: true,
				renderer: (status) => <FollowUpStatusPill status={status} />,
			},
			{
				label: strings('actions'),
				align: 'center',
				sortable: false,
				mobile: true,
				key: (row) => row,
				renderer: (row) => (
					<TableActionsWrapper>
						<TableActionButton title='Lead remarks' onClick={(e) => onRemarksClick(e, row)}>
							<RateReview />
						</TableActionButton>
					</TableActionsWrapper>
				),
			},
		]
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const changePageHandler = (next = true) => {
		dispatch(actions.changePage(next))
	}

	// Review icon — opens the "Lead remarks" drawer (follow up status + comments).
	const onRemarksClick = (e, row) => {
		e.stopPropagation()
		globalDispatch(toggleDrawer(true, DRAWER_TYPES.TENDERBOOK_LEAD_REMARKS, { label: 'Lead remarks', update, data: row }))
	}

	return (
		<FullHeightPageLevelTableWrapper>
			<Table
				data={state.data}
				columns={columns}
				loading={state.loading}
				rowsToDisplay={ROWS_PER_PAGE}
				totalItemCount={state.total_count}
				page={state.query.page}
				onPageChange={changePageHandler}
				rowClickable={false}
				emptyState={{ text: 'No leads found' }}
				scrollable
			/>
		</FullHeightPageLevelTableWrapper>
	)
}

export default TenderBookLeadsList
